// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IAffiliationEnumDto } from './affiliation-enum-dto.g';
import { IMessageAudienceDto } from './message-audience-dto.g';

export const messageDto = {
    guid: 'guid',
    domain_Guid: 'domain_Guid',
    domain_Name: 'domain_Name',
    project_Guid: 'project_Guid',
    project_Name: 'project_Name',
    task_Guid: 'task_Guid',
    task_Subject: 'task_Subject',
    subject: 'subject',
    body: 'body',
    sentOn: 'sentOn',
    timeZoneId: 'timeZoneId',
    sender_Guid: 'sender_Guid',
    sender_Name: 'sender_Name',
    sender_Affiliation: 'sender_Affiliation',
    sender_OrganisationName: 'sender_OrganisationName',
    acknowledgeRequired: 'acknowledgeRequired',
    mine: 'mine',
    isRecipient: 'isRecipient',
    readOn: 'readOn',
    acknowledgedOn: 'acknowledgedOn',
    canDelete: 'canDelete',
    canAcknowledge: 'canAcknowledge',
    canSeeRecipients: 'canSeeRecipients',
    audienceDtos: 'audienceDtos',
} as const;

export type TMessageDto = (typeof messageDto)[keyof typeof messageDto];

export interface IMessageDto {
    [messageDto.guid]: string | null;
    [messageDto.domain_Guid]: string | null;
    [messageDto.domain_Name]: string | null;
    [messageDto.project_Guid]: string | null;
    [messageDto.project_Name]: string | null;
    [messageDto.task_Guid]: string | null;
    [messageDto.task_Subject]: string | null;
    [messageDto.subject]: string | null;
    [messageDto.body]: string | null;
    [messageDto.sentOn]: string | null;
    [messageDto.timeZoneId]: string | null;
    [messageDto.sender_Guid]: string | null;
    [messageDto.sender_Name]: string | null;
    [messageDto.sender_Affiliation]: IAffiliationEnumDto | null;
    [messageDto.sender_OrganisationName]: string | null;
    [messageDto.acknowledgeRequired]: boolean | null;
    [messageDto.mine]: boolean | null;
    [messageDto.isRecipient]: boolean | null;
    [messageDto.readOn]: string | null;
    [messageDto.acknowledgedOn]: string | null;
    [messageDto.canDelete]: boolean | null;
    [messageDto.canAcknowledge]: boolean | null;
    [messageDto.canSeeRecipients]: boolean | null;
    [messageDto.audienceDtos]: IMessageAudienceDto[] | null;
}

export class MessageDto
    implements IMessageDto
{
    [messageDto.guid]: string | null = null;
    [messageDto.domain_Guid]: string | null = null;
    [messageDto.domain_Name]: string | null = null;
    [messageDto.project_Guid]: string | null = null;
    [messageDto.project_Name]: string | null = null;
    [messageDto.task_Guid]: string | null = null;
    [messageDto.task_Subject]: string | null = null;
    [messageDto.subject]: string | null = null;
    [messageDto.body]: string | null = null;
    [messageDto.sentOn]: string | null = null;
    [messageDto.timeZoneId]: string | null = null;
    [messageDto.sender_Guid]: string | null = null;
    [messageDto.sender_Name]: string | null = null;
    [messageDto.sender_Affiliation]: IAffiliationEnumDto | null = null;
    [messageDto.sender_OrganisationName]: string | null = null;
    [messageDto.acknowledgeRequired]: boolean | null = null;
    [messageDto.mine]: boolean | null = null;
    [messageDto.isRecipient]: boolean | null = null;
    [messageDto.readOn]: string | null = null;
    [messageDto.acknowledgedOn]: string | null = null;
    [messageDto.canDelete]: boolean | null = null;
    [messageDto.canAcknowledge]: boolean | null = null;
    [messageDto.canSeeRecipients]: boolean | null = null;
    [messageDto.audienceDtos]: IMessageAudienceDto[] | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IMessageData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[messageDto.guid] = modelData[messageData.guid];
    }

    static create(modelData?: any | null): IMessageDto | null {
        return modelData ? new MessageDto(modelData) : null;
    }
}
